import { Card } from 'antd';
import React from 'react';
import { Route, Switch } from 'react-router';
import ConsultivoConsultaLogsDetailPage from "./_detail";

export default function ConsultivoConsultaLogsPage() {
  return (
    <Card bordered={false}>
      <Switch>
        <Route path="/consultivo/consultas/:consultaId" component={ConsultivoConsultaLogsDetailPage}/>
      </Switch>
    </Card>);
}
